module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-thirteen.fa63d748.png";